/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_Loading_MediaInputs */

const en_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading media...`)
};

const fr_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des medias...`)
};

const de_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien werden geladen...`)
};

const it_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento del contenuto multimediale...`)
};

const ru_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка медиафайлов...`)
};

const es_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando medios...`)
};

const zh_cn2_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载媒体……`)
};

const ja_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアを読み込んでいます...`)
};

const hi_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया लोड हो रहा है...`)
};

const pt_pt2_iconik_import_status_loading_media = /** @type {(inputs: Iconik_Import_Status_Loading_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando mídia...`)
};

/**
* | output |
* | --- |
* | "Loading media..." |
*
* @param {Iconik_Import_Status_Loading_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_loading_media = /** @type {((inputs?: Iconik_Import_Status_Loading_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_Loading_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_status_loading_media(inputs)
	if (locale === "de") return de_iconik_import_status_loading_media(inputs)
	if (locale === "it") return it_iconik_import_status_loading_media(inputs)
	if (locale === "ru") return ru_iconik_import_status_loading_media(inputs)
	if (locale === "es") return es_iconik_import_status_loading_media(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_status_loading_media(inputs)
	if (locale === "ja") return ja_iconik_import_status_loading_media(inputs)
	if (locale === "hi") return hi_iconik_import_status_loading_media(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_status_loading_media(inputs)
	return en_iconik_import_status_loading_media(inputs)
});